import useFinancial from '../../../hooks/useFinancial'
import { Typography, MenuItem, FormControlLabel, Checkbox, FormControl, InputLabel, Select, Paper, Switch} from '@mui/material'
import { isFinancial } from '../../../utils/tools'
import { aggregationOptions as options, getDisableGroupByOptions, getDatasetFrequency } from '../../../utils/aggregationUtils'
import { mainGraphColorNames } from '../../../utils/constants'
import styles from './ExportForm.module.scss'

const FormControlPaper = ({ children }) => (
    <Paper classes={{root: styles['select-container']}}>
        <FormControl variant="filled" fullWidth>
            {children}
        </FormControl>
    </Paper>
)

const ExportDataset = ({ field, updateField, datasets, ticker }) => {
    const { getFinancialDataFrequency } = useFinancial(ticker)

    const handleCheck = (event) => updateField({ ...field, [event.target.name]: event.target.checked }, field.i)
    const handleChange = (event) => {
        const fieldKey = event.target.name
        const value = event.target.value
        updateField({ ...field, [fieldKey]: { value } }, field.i)
    }

    const financial = isFinancial(field.dataset.value)

    const datasetExport = () => {
        const datasetFrequency = financial ? getFinancialDataFrequency(field.column.value) : getDatasetFrequency(datasets, field.dataset.value)
        const aggOptions = getDisableGroupByOptions(datasetFrequency)
        const colorName = mainGraphColorNames[field.i]

        return (
            <div>
                <div className={styles['flex-between']}>
                    <FormControlLabel
                        value={field.name}
                        control={<Checkbox color={colorName} name="enable" onClick={handleCheck} checked={field.enable} />}
                        label={<Typography color={colorName}>{field.name}</Typography>}
                        labelPlacement="end"
                    />
                    {field.enable && (
                        <FormControlLabel
                            value={field.p_change}
                            control={<Switch color={colorName} name="p_change" onClick={handleCheck} checked={field.p_change} />}
                            label={<Typography color={colorName}>% Change</Typography>}
                            labelPlacement="end"
                        />
                    )}
                </div>
                {field.enable && (
                    <>
                        <div className={styles['select-group']}>
                            <FormControlPaper>
                                <InputLabel classes={{root: styles['select-label']}}>Group By</InputLabel>
                                <Select name="group" value={field.group.value} onChange={handleChange}>
                                    {aggOptions.map(({ value, name, disable }) => ((value !== 'daily' && !disable) && <MenuItem key={value} value={value}>{name}</MenuItem>))}
                                </Select>
                            </FormControlPaper>
                            <FormControlPaper>
                                <InputLabel classes={{root: styles['select-label']}}>Aggregate By</InputLabel>
                                <Select name="agg" value={field.agg.value} onChange={handleChange}>
                                    {options.agg.map(({ value, name }) => <MenuItem key={value} value={value}>{name}</MenuItem>)}
                                </Select>
                            </FormControlPaper>
                        </div>
                    </>
                )}
            </div>
        )
    }

    return datasetExport()
}


export default function ExportForm({ updateField, form, datasets }) {
    return (
        <>
            <div className={styles['form']}>
                {form.map((field, i) =>
                    <ExportDataset
                        key={i}
                        field={field}
                        updateField={updateField}
                        datasets={datasets}
                    />
                )}
            </div>
        </>
    )
}
